import axios from 'axios';
import apiClient from './apiClient';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

const publicClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

const ratingService = {
  // Admin endpoints
  getAll: async (params = {}) => {
    const response = await apiClient.get('/ratings', { params });
    return response.data;
  },

  getStats: async () => {
    const response = await apiClient.get('/ratings/stats');
    return response.data;
  },

  remove: async (id) => {
    const response = await apiClient.delete(`/ratings/${id}`);
    return response.data;
  },

  // Public endpoints
  getByToken: async (token) => {
    const response = await publicClient.get(`/public/ratings/${token}`);
    return response.data;
  },

  submitRating: async (token, data) => {
    const response = await publicClient.post(`/public/ratings/${token}`, data);
    return response.data;
  },
};

export default ratingService;
